import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import Pagination from "react-js-pagination";
import "../../../components/Style/Table.css"
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter
} from "@material-ui/core";
import OrgCell from "../../../components/OrgCell";

const NOWRAP_COLS = ['메일', '연락처', '플랜 시작일', '플랜 종료일'];

export default function PaymentTable(props){
  const filterKeyword = props.filterKeyword || '';
  const row = ['NO', '이름', '플랜명', '메일', '연락처', '소속', '프로젝트 수', '플랜 시작일', '플랜 종료일'];
  const searchTargets = props.searchTargets;
  const totalData = Array.isArray(props.totalData) ? props.totalData : [];
  const [dataCnt, setDataCnt] = useState(0);

  // pagination
  const [page, setPage] = useState(1);
  const [currentPost, setCurrentPost] = useState([]);
  const postPerPage = 10;
  const handlePageChange = (page) => {
    setPage(page);
  };

  const searchItem = (filterKeyword) => {
    if (filterKeyword !== ''){
      const filteredData = totalData.filter((item) => {
        return searchTargets.some((target) => {
          if (item[target] && typeof item[target] === 'string') {
            return item[target].toLowerCase().includes(filterKeyword.toLowerCase());
          }
        })
      });
      // pagination filter data slice
      setCurrentPost(filteredData.slice(page*postPerPage-postPerPage, page*postPerPage));
      setDataCnt(filteredData.length);
    } else {
      // pagination total data slice
      setCurrentPost(totalData.slice(page*postPerPage-postPerPage, page*postPerPage));
      setDataCnt(totalData.length);
    }
  }
  useEffect(() => {
    searchItem(filterKeyword)
  }, [totalData, page, filterKeyword])

  return(
    <div>
      <TableContainer>
        <MemberTable className="mb-0">
          <colgroup>
            <col style={{ width: "7%" }} />
            <col style={{ width: "8%" }} />
            <col style={{ width: "12%" }} />
            <col style={{ width: "17%" }} />
            <col style={{ width: "11%" }} />
            <col style={{ width: "13%" }} />
            <col style={{ width: "12%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "10%" }} />
          </colgroup>
          <TableHead>
            <TableRow>
              {row && row.map(headerItem => (
                <HeadCell key={headerItem} $nowrap={NOWRAP_COLS.includes(headerItem)}>
                  {headerItem}
                </HeadCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {currentPost && currentPost.map(item => (
              <TableRow key={item.num}>
                <TableCell style={{ textAlign: 'center'}}>{item.member_seq}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.name}</TableCell>
                <TableCell style={{ textAlign: 'center'}}>{item.note || '-'}</TableCell>
                <NoWrapCell>{item.email}</NoWrapCell>
                <NoWrapCell>{item.phone_number || '-'}</NoWrapCell>
                <TableCell style={{ textAlign: 'center'}}>
                  <OrgCell name={item.org_name} type={item.org_type} />
                </TableCell>
                <TableCell style={{ textAlign: 'center'}}>
                  통합 프로젝트: {item.total_project_cnt ?? 0}<br />특허 프로젝트: {item.patents_project_cnt ?? 0}
                </TableCell>
                <NoWrapCell>{item.start_date}</NoWrapCell>
                <NoWrapCell>{item.end_date}</NoWrapCell>
              </TableRow>
            ))}
          </TableBody>
        </MemberTable>
        <RealTableFooter style={{ display: "flex", justifyContent: "center" }}>
          <Pagination
            activePage={page}
            itemsCountPerPage={postPerPage}
            totalItemsCount={dataCnt}
            pageRangeDisplayed={5}
            prevPageText={"<"}
            nextPageText={">"}
            onChange={handlePageChange}
          />
        </RealTableFooter>
      </TableContainer>
    </div>
  )
}

const RealTableFooter = styled (TableFooter)`
    display: flex;
    justify-content: center;
    text-align: center;
`

const MemberTable = styled(Table)`
    table-layout: fixed;
    width: 100%;
`

const HeadCell = styled(TableCell)`
    text-align: center !important;
    white-space: ${({ $nowrap }) => ($nowrap ? 'nowrap' : 'normal')} !important;
    font-weight: 700;
`

const NoWrapCell = styled(TableCell)`
    text-align: center !important;
    white-space: nowrap !important;
`